import { render, staticRenderFns } from "./default.vue?vue&type=template&id=b8b670d0&"
import script from "./default.ts?vue&type=script&lang=ts&"
export * from "./default.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports